module.exports = __webpack_public_path__ + "static/assets/f3d64c8ef45a9a3e62da8eba711c8199.png";